import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Subject, Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { Sgkb502aRequest, Sgkb502aResponse, SGKB502AService } from 'sg-api';
import { SgkbConstains } from '../../../../sg-kb-shared/sg-kb-constans';

@Injectable({
  providedIn: 'root'
})
export class UsedSgkb122dSgkb502aService {
  /** ガス設備関連情報取得結果のSubject */
  private _commonAceptSearchResult$ = new Subject<Sgkb502aResponse>();

  /**
  * ガス設備関連情報取得結果のobservable提供
  *
  * @readonly
  * @memberof UsedSgkb122dSgkb502aService
  */
  get valueChanges() {
    return this._commonAceptSearchResult$.asObservable();
  }

  /**
   * コンストラクタ
   * @param {SGKB502AService} SGKB502AService
   * @param {ApiCommonService} apiCommonService
   * @memberof UsedSgkb122dSgkb502aService
   */
  constructor(
    private sGKB502AService: SGKB502AService,
    private apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig
  ) { }

  /**
   * ガス設備関連情報取得API呼び出し
   * @param {*} value
   * @return {*}  {Observable<Sgkb502aResponse>}
   * @memberof UsedSgkb122dSgkb502aService
   */
  searchContractor(value: Sgkb502aRequest): Observable<Sgkb502aResponse> {
    // 検索条件を保存
    return this.sGKB502AService.sGKB502APost(<Sgkb502aRequest>this.apiCommonService.setRequestCommon(value), 'response')
      .pipe(
        map(response => {
          // エラーが設定されていないかチェックする
          this.apiCommonService.checkErrorNoSearchData(response);
          this.apiCommonService.checkError(response);

          this._commonAceptSearchResult$.next(response.body);
          return response.body;
        }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, SgkbConstains.MESSAGE.ID_SGKB,
            SgkbConstains.MESSAGE.APINAME_SGKB502A);
          return throwError(err.message);
        })
      );
  }
}
